<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Monitoreo Cola CRM",
            items: [
                {
                    text: "Configuración",
                    href: "/"
                },
                {
                    text: "Monitoreo Cola CRM",
                    active: true
                }
            ],
            loading: false,
            refrescando: null,
            resumen: {
                cola_pendiente_jobs: 0,
                cola_fallidos_jobs: 0,
                cola_antiguedad_minutos: null,
                asistentes_total: 0,
                asistentes_pendientes: 0,
                asistentes_finalizados: 0,
                asistentes_error_envio: 0,
                avance_porcentaje: 0,
                rate_por_minuto: 0,
                procesados_ultimos_10_min: 0,
            },
            estados: [],
            pendientesPorEvento: [],
            actualizadoEn: null,
            error: "",
        };
    },
    computed: {
        esUsuarioAutorizado() {
            return Number(this.user && this.user.id) === 1;
        },
        progresoLabel() {
            return `${Number(this.resumen.avance_porcentaje || 0).toFixed(2)}%`;
        },
        edadColaLabel() {
            if (this.resumen.cola_antiguedad_minutos === null || this.resumen.cola_antiguedad_minutos === undefined) {
                return "Sin jobs pendientes";
            }

            return `${this.resumen.cola_antiguedad_minutos} min`;
        }
    },
    methods: {
        async cargarResumen() {
            if (!this.esUsuarioAutorizado) {
                return;
            }

            this.loading = true;
            this.error = "";

            try {
                const response = await axios.get('/api/cola_crm_resumen');
                const data = response.data || {};

                if (!data.estado) {
                    this.error = data.mensaje || 'No se pudo obtener el resumen de cola.';
                    return;
                }

                this.resumen = data.resumen || this.resumen;
                this.estados = Array.isArray(data.estados) ? data.estados : [];
                this.pendientesPorEvento = Array.isArray(data.pendientes_por_evento) ? data.pendientes_por_evento : [];
                this.actualizadoEn = data.actualizado_en || null;
            } catch (error) {
                const status = error && error.response ? error.response.status : null;
                if (status === 403) {
                    window.location.href = '/';
                    return;
                }

                this.error = 'Error al cargar el monitoreo de cola CRM.';
            } finally {
                this.loading = false;
            }
        },
        formatDateTime(value) {
            if (!value) {
                return '-';
            }

            return new Date(value).toLocaleString('es-CL', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        },
        forceRefresh() {
            this.cargarResumen();
        }
    },
    created() {
        if (!this.esUsuarioAutorizado) {
            window.location.href = '/';
            return;
        }

        this.cargarResumen();
        this.refrescando = setInterval(() => {
            this.cargarResumen();
        }, 30000);
    },
    beforeDestroy() {
        if (this.refrescando) {
            clearInterval(this.refrescando);
            this.refrescando = null;
        }
    }
};
</script>

<template>
    <Layout>
        <div v-if="!esUsuarioAutorizado"></div>
        <template v-else>
            <PageHeader :title="title" :items="items" />

            <div class="row mb-3">
                <div class="col-12 d-flex justify-content-between align-items-center">
                    <div>
                        <small class="text-muted">Ultima actualizacion: {{ formatDateTime(actualizadoEn) }}</small>
                    </div>
                    <button class="btn btn-sm btn-primary" @click="forceRefresh" :disabled="loading">
                        Actualizar ahora
                    </button>
                </div>
            </div>

            <div v-if="error" class="alert alert-danger">{{ error }}</div>

            <div class="row">
                <div class="col-md-3 col-sm-6">
                    <div class="card mini-stats-wid">
                        <div class="card-body">
                            <p class="text-muted mb-2">Jobs pendientes cola</p>
                            <h4 class="mb-0">{{ resumen.cola_pendiente_jobs }}</h4>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6">
                    <div class="card mini-stats-wid">
                        <div class="card-body">
                            <p class="text-muted mb-2">Jobs fallidos cola</p>
                            <h4 class="mb-0 text-danger">{{ resumen.cola_fallidos_jobs }}</h4>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6">
                    <div class="card mini-stats-wid">
                        <div class="card-body">
                            <p class="text-muted mb-2">Rate por minuto</p>
                            <h4 class="mb-0 text-success">{{ resumen.rate_por_minuto }}</h4>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6">
                    <div class="card mini-stats-wid">
                        <div class="card-body">
                            <p class="text-muted mb-2">Antiguedad cola</p>
                            <h4 class="mb-0">{{ edadColaLabel }}</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <h5 class="mb-0">Avance global CRM asistentes</h5>
                        <span class="font-weight-bold">{{ progresoLabel }}</span>
                    </div>
                    <b-progress :value="resumen.avance_porcentaje" max="100" height="20px" variant="success"></b-progress>

                    <div class="row mt-3">
                        <div class="col-md-3 col-sm-6">
                            <p class="text-muted mb-1">Total asistentes</p>
                            <h5>{{ resumen.asistentes_total }}</h5>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <p class="text-muted mb-1">Pendientes</p>
                            <h5 class="text-warning">{{ resumen.asistentes_pendientes }}</h5>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <p class="text-muted mb-1">Finalizados</p>
                            <h5 class="text-success">{{ resumen.asistentes_finalizados }}</h5>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <p class="text-muted mb-1">Error envio</p>
                            <h5 class="text-danger">{{ resumen.asistentes_error_envio }}</h5>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="mb-3">Distribucion por estado CRM</h5>
                            <div class="table-responsive">
                                <table class="table table-sm table-striped mb-0">
                                    <thead>
                                        <tr>
                                            <th>Estado CRM</th>
                                            <th class="text-right">Cantidad</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in estados" :key="item.estado_crm">
                                            <td>{{ item.estado_crm }}</td>
                                            <td class="text-right">{{ item.total }}</td>
                                        </tr>
                                        <tr v-if="!estados.length">
                                            <td colspan="2" class="text-center text-muted">Sin datos</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="mb-3">Top eventos con pendientes</h5>
                            <div class="table-responsive">
                                <table class="table table-sm table-striped mb-0">
                                    <thead>
                                        <tr>
                                            <th>Evento ID</th>
                                            <th class="text-right">Pendientes</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in pendientesPorEvento" :key="item.evento_id">
                                            <td>{{ item.evento_id }}</td>
                                            <td class="text-right">{{ item.total_pendientes }}</td>
                                        </tr>
                                        <tr v-if="!pendientesPorEvento.length">
                                            <td colspan="2" class="text-center text-muted">Sin pendientes</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Layout>
</template>
